import * as Yup from 'yup';

const categoryFormValidationSchema = Yup.object().shape({
  // 항상 필수값인 필드들
  pCategory: Yup.string().required('상위 카테고리를 입력해주세요.'),
  useYn: Yup.boolean().required('사용여부를 선택해주세요.'),
  categoryNm: Yup.string().required('카테고리명을 입력해주세요.'),
  mainTitle: Yup.string().required('제목을 입력해주세요.'),
  mainDesc: Yup.string().required('설명을 입력해주세요.'),
  // 선택적 필드들
  subTitle: Yup.string(),
  subDesc: Yup.string(),
  pipeline: Yup.string(),
  pipelineList: Yup.string(),
});

export default categoryFormValidationSchema;
